import { useEffect, useMemo } from 'react';
import { Alert } from '@mui/material';
import ResolveActionsModalContent from 'app/components/ReusableUIComponents/HighLevelComponents/ResolveActionsModalMAIQ/components/ResolveActionsModalContent';
import { useResolveActionsModalMAIQ } from 'app/components/ReusableUIComponents/HighLevelComponents/ResolveActionsModalMAIQ/hooks/useResolveActionsModalMAIQ';
import type { SegmentAttentionContext } from 'app/utils/hilSegmentsAttentionUtils';

type TemplatePendingApprovalEntityPanelProps = {
  open: boolean;
  dealerId: string;
  templateIds: string[];
  context: SegmentAttentionContext;
  onSuccess?: () => void;
};

export default function TemplatePendingApprovalEntityPanel({
  open,
  dealerId,
  templateIds,
  context,
  onSuccess,
}: TemplatePendingApprovalEntityPanelProps) {
  const modal = useResolveActionsModalMAIQ({
    dealerId,
    templateIds,
    segmentName: context?.segment_name,
    onSuccess,
  });

  const contextResolved = useMemo(
    () =>
      context ?? {
        segment_name: '',
        reason_code: '',
        issue: '',
      },
    [context],
  );

  useEffect(() => {
    if (!open) {
      modal.resetModalState();
    }
  }, [modal, open]);

  if (!dealerId.trim()) {
    return (
      <Alert severity="info" sx={{ borderRadius: 2 }}>
        Select a dealer to view templates.
      </Alert>
    );
  }

  return (
    <ResolveActionsModalContent
      dealerId={dealerId}
      templateIds={templateIds}
      context={contextResolved}
      modal={modal}
      hideContextChips
    />
  );
}

